import { Box, Paper, Typography, styled } from "@mui/material";
import { specialFont } from "../../Infrastructure/Theme/fontFamily";

export const styles = {
  mainGrid1: { p: { xs: 1}, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
  boxTypoHeading: { pb:1 },
  boxTypoDescription: { borderRadius: "20px" },
  linkText: { textDecoration: "underline", cursor: "pointer", fontSize:{xs:"18px",sm: "22px", md:"28px"},   textUnderlineOffset: "4px" },

  centerFlex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  rowCenterFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  mainCardsGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 10,
    gap: { xs: 2, md: 0 }
  },

  columnCenterFlex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};

export const Item = styled(Paper)(({ theme, is_small_screen }) => ({
  textAlign: "start",
  minHeight: 200,
  width: is_small_screen ? 350 : 414,
  borderRadius: `${20} !important`,
  fontSize: "18px",
  padding: 20,
  border: "1px solid black",
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px", // Font size for sm
    minHeight: 220,
  }
}));

export const BannerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(3),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(6),
  },
}));

export const Header = styled(Typography)(({ theme }) => ({
  fontFamily: `${specialFont} !important`,
  color: theme.palette.primary.main,
  fontSize: "30px", // Default font size for xs
  [theme.breakpoints.up("sm")]: {
    fontSize: "34px", // Font size for sm
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "38px", // Font size for md and up
  },
}));
export const DescriptionText = styled(Typography)(({ theme }) => ({
  fontSize: "18px", // Default font size for xs
  textAlign:"start",
  fontWeight:'normal',
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px", // Font size for sm
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "22px", // Font size for md and up
  },
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontWeight: "bold",
  fontSize: "18px", // Default font size for xs
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px", // Font size for sm
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "22px", // Font size for md and up
  },
}));

export const Image = styled("img")({
  maxWidth: "100%",
  height: "auto",
});

export const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "70%",
      height: "100%",
      backgroundImage: `linear-gradient(to right,
        rgba(255, 255, 255, 0) 10%, 
        rgba(255, 255, 255, 0.2) 30%,
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0.8) 75%, 
        rgba(255, 255, 255, 1) 100%)`,
      zIndex: 1,
    },
  },
}));
